import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CarouselHorizontal"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 19.5H7.5C6.67157 19.5 6 18.8284 6 18V6C6 5.17157 6.67157 4.5 7.5 4.5H16.5C17.3284 4.5 18 5.17157 18 6V18C18 18.8284 17.3284 19.5 16.5 19.5ZM7.5 6V18H16.5V6H7.5ZM3 18H0V16.5H3V7.5H0V6H3C3.82843 6 4.5 6.67157 4.5 7.5V16.5C4.5 17.3284 3.82843 18 3 18ZM24 18H21C20.1716 18 19.5 17.3284 19.5 16.5V7.5C19.5 6.67157 20.1716 6 21 6H24V7.5H21V16.5H24V18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CarouselHorizontal.vue"]]);
